import { cn } from "@istari-frontend/shared";
import { Tooltip, TooltipContent, TooltipTrigger } from "@istari-frontend/ui";
import type { ReactNode } from "react";

type DisabledActionTooltipProps = {
  reason?: string;
  className?: string;
  tabIndex?: number;
  children: ReactNode;
};

export const NO_EDIT_ACCESS_REASON = "You do not have edit access to this system.";

export function DisabledActionTooltip({ reason, className, tabIndex, children }: DisabledActionTooltipProps) {
  if (!reason) {
    return children;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {/* Disabled controls emit no pointer events, so the tooltip anchors to this enabled span instead. */}
        <span className={cn("inline-flex", className)} tabIndex={tabIndex}>
          {children}
        </span>
      </TooltipTrigger>
      <TooltipContent>{reason}</TooltipContent>
    </Tooltip>
  );
}
